/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box, Typography, Grid, Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { Phone } from '@mui/icons-material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import HomeIcon from '@mui/icons-material/Home';
import { capitalizeWords } from '../../utilities/capitalizeWords';

const style = {
  mr: 3,
  fontWeight: 600,
};

const boxStyle = {
  mx: 0,
  my: 1,
  px: 3,
  py: 2,
};

const boxInfoStyle = {
  bgcolor: '#3A4152',
  width: 1,
  p: 1,
  px: 2,
  borderRadius: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const detailsStyle = {
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 1,
  display: 'inline-block',
  cursor: 'default',
  minHeight: 24,
};

export const EmergencyContact = (props) => {
  const [emergencyContact, setEmergencyContact] = useState({});

  useEffect(() => {
    const fetchEmergencyContact = async () => {
      try {
        const response = await fetch(
          apiUrl(`/eis/emprelations/${props.empId}/emergency`),
          {
            method: 'GET',
            credentials: 'include',
          }
        );

        const result = await response.json();

        if (result.success) {
          setEmergencyContact(result.data);
        } else {
          console.warn(result);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchEmergencyContact();
  }, []);

  const fullName = [
    emergencyContact?.firstname,
    emergencyContact?.middlename,
    emergencyContact?.lastname,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={boxStyle}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <Box sx={boxInfoStyle}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
                Name:
              </Typography>

              <Tooltip title={capitalizeWords(fullName)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {fullName}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box sx={boxInfoStyle}>
              <HandshakeIcon sx={{ fontSize: 22, mr: 2 }} />
              <Tooltip
                title={capitalizeWords(emergencyContact.relationship)}
                arrow
              >
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {emergencyContact.relationship}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <SmartphoneIcon sx={{ fontSize: 22, mr: 2 }} />
              <Tooltip title={emergencyContact.cellphone} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {emergencyContact.cellphone}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <Phone sx={{ fontSize: 22, mr: 2 }} />
              <Tooltip title={emergencyContact.telephone} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {emergencyContact.telephone}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={boxInfoStyle}>
              <HomeIcon sx={{ fontSize: 22, mr: 2 }} />
              <Tooltip title={capitalizeWords(emergencyContact.address)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {emergencyContact.address}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
